"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PipelineService = void 0;
var inversify_1 = require("inversify");
/**
 * dispatch 虽然支持异步，但实际在使用时，可能并不想让代码 await 这次 dispatch，再手动 dispatch 下一个
 * 特别是 click 这些埋点，如果 api 是异步的，对业务代码污染太多，需要全都是 async await。
 * 这样同一时间内触发两次 click 埋点，数据会被覆盖
 * 因此这里支持按顺序执行 dispatch。但实际上 pipeline dispatch 通常都是不按顺序执行
 * 其实可在 behavior-v4 中通过数据的处理，比如将每次 dispatch 产生的数据放到不同的地方，再找到适当的时机将数据整合，存储
 * 但有些复杂，暂时如此处理
 */
var PipelineService = /** @class */ (function () {
    function PipelineService() {
        this.mode = "parallel";
        this.middlewares = [];
        this.watingQueue = [];
        this.running = false;
    }
    PipelineService.prototype.reset = function () {
        this.running = false;
    };
    PipelineService.prototype.runWatingQueue = function () {
        return __awaiter(this, void 0, void 0, function () {
            var waitToDispatch, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.running) {
                            return [2 /*return*/];
                        }
                        this.running = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        waitToDispatch = this.watingQueue[0];
                        return [4 /*yield*/, waitToDispatch()];
                    case 2:
                        _a.sent();
                        this.watingQueue = this.watingQueue.slice(1);
                        this.reset();
                        if (this.watingQueue.length) {
                            this.runWatingQueue();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.reset();
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PipelineService.prototype.runInSequence = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.watingQueue.push(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.applyMiddlewares(context, this.middlewares)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); });
                        return [4 /*yield*/, this.runWatingQueue()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PipelineService.prototype.runInParallel = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.applyMiddlewares(context, this.middlewares)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PipelineService.prototype.applyMiddlewares = function (context, middlewares) {
        return __awaiter(this, void 0, void 0, function () {
            var mw, newContext;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!middlewares.length) {
                            return [2 /*return*/];
                        }
                        mw = middlewares[0];
                        return [4 /*yield*/, mw.execute(context)];
                    case 1:
                        newContext = _a.sent();
                        // TODO: catch error?
                        return [4 /*yield*/, this.applyMiddlewares(newContext || context, middlewares.slice(1))];
                    case 2:
                        // TODO: catch error?
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PipelineService.prototype.setExecuteMode = function (mode) {
        this.mode = mode;
    };
    PipelineService.prototype.use = function () {
        var _a;
        var middlewares = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            middlewares[_i] = arguments[_i];
        }
        (_a = this.middlewares).push.apply(_a, middlewares);
    };
    PipelineService.prototype.dispatch = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.mode === "sequence")) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.runInSequence(context)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.runInParallel(context)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PipelineService.prototype.clear = function () {
        this.middlewares = [];
    };
    PipelineService = __decorate([
        (0, inversify_1.injectable)()
    ], PipelineService);
    return PipelineService;
}());
exports.PipelineService = PipelineService;
